import styled from 'styled-components';

import PageList from './PageList';
import CategoryList from '../../CategoryList';
import OptionsList from './OptionsList';

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
`;

const Pages = styled(PageList)``;

const Categories = styled(CategoryList)`
    margin: 16px 0;
    flex: 0 0 auto;
`;

const Options = styled(OptionsList)`
    flex: 1;
`;

export {
    Wrap,
    Pages,
    Categories,
    Options,
};
